import { render, staticRenderFns } from "./RelatorioPage.vue?vue&type=template&id=437638c2&"
import script from "./RelatorioPage.vue?vue&type=script&lang=ts&"
export * from "./RelatorioPage.vue?vue&type=script&lang=ts&"
import style0 from "./RelatorioPage.vue?vue&type=style&index=0&id=437638c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports